import { render, staticRenderFns } from "./KeyboardActionsDescription.vue?vue&type=template&id=5f331c06&scoped=true&"
import script from "./KeyboardActionsDescription.vue?vue&type=script&lang=js&"
export * from "./KeyboardActionsDescription.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_top_bar.scss?vue&type=style&index=0&id=5f331c06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f331c06",
  null
  
)

export default component.exports